// flashtalkingSegments.js
import axios from "axios";
// 1) Load the FT segment JS (CORS-safe via <script>) and resolve window.ftSegmentList
export function loadFlashtalkingFtSegmentList(src, type_get, timeoutMs) {
	timeoutMs = timeoutMs || 4000;
	if (type_get) {
		try {
			return new Promise(function (resolve, reject) {
				var script = document.createElement("script");
				var done = false;
				var timer = window.setTimeout(function () {
					if (done) return;
					done = true;
					script.remove();
					reject(new Error("Flashtalking segment script timed out"));
				}, timeoutMs);

				script.async = true;
				script.src = src; // e.g. https://servedby.flashtalking.com/segment/read/;;javascript/
				script.onload = function () {
					if (done) return;
					done = true;
					window.clearTimeout(timer);
					// Read the discovered global

					var list = window.ftSegmentList;
					if (Array.isArray(list)) {
						resolve(list.slice()); // return a shallow copy
					} else {
						reject(
							new Error(
								"Segment script loaded but window.ftSegmentList is not an array"
							)
						);
					}
					return;
				};
				// var list = window.ftSegmentList;
				// if (Array.isArray(list)) {
				// 	resolve(list.slice()); // return a shallow copy
				// } else {
				// 	reject(
				// 		new Error(
				// 			"Segment script loaded but window.ftSegmentList is not an array"
				// 		)
				// 	);
				// }
				// };
				script.onerror = function () {
					if (done) return;
					done = true;
					window.clearTimeout(timer);
					reject(new Error("Failed to load Flashtalking segment script"));
				};

				document.head.appendChild(script);
			});
		} catch (err) {
			console.error("Error loading Flashtalking segment script:", err);
		}
	} else {
		// try {
		// the src should load in an iframe and in one second that iframe gets removed called modIframe
		return new Promise(function (resolve, reject) {
			document.getElementById("modIframe").src = src;
			setTimeout(() => {
				// document.getElementById("modIframe").src = "";
				window.location.reload();
			}, 500);
		});
	}
}

// 2) Normalize the array into a map of { [m]: s }, keeping the entry with the highest t
export function ftSegmentsToMap(ftSegmentList) {
	var map = Object.create(null);
	var seenT = Object.create(null);

	(ftSegmentList || []).forEach(function (item) {
		if (!item || typeof item !== "object") return;
		var m = item.m;
		var s = item.s;
		var t = typeof item.t === "number" ? item.t : -Infinity;
		// if (!m) return;
		if (!m) {
			m = null;
		}
		if (!(m in seenT) || t > seenT[m]) {
			seenT[m] = t;
			map[m] = s;
		}
	});

	return map;
}
